import { TemplateConfig } from '../types';

export const entrepreneurshipSpreadConfig: TemplateConfig = {
  id: 'entrepreneurship-spread',
  name: '创业的情况',
  description: '分析创业能力、运营状况与未来发展',
  cardCount: 4,
  
  fieldDefaults: {
    title: '创业的情况',
    customerQuestion: '分析我的创业情况。',
    cardPlaceholders: [
      '请输入第 1 张牌 最上方的牌',
      '请输入第 2 张牌 最左边的牌',
      '请输入第 3 张牌 最右边的牌',
      '请输入第 4 张牌 最下方的牌'
    ],
    cardInfos: [
      '我具备这个能力吗',
      '运营状况',
      '会负债吗',
      '未来发展情况如何'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#3f8600',
    backgroundColor: '#f6ffed',
    icon: '🚀'
  }
};
